module.exports = __webpack_public_path__ + "img/upsell_payments_page.864aaefe.png";